import { createAsyncThunk, ThunkDispatch } from '@reduxjs/toolkit';
import eventService from './Event.service';
import { errorHandlerThunk } from '../App/App.thunk';

export const getEventMetaThunk = createAsyncThunk(
  'event/getEventMetaThunk',
  async (_: undefined, thunkAPI) => {
    const response = await eventService.getMeta();
    return response.data;
  },
);

export const getEventListThunk = createAsyncThunk(
  'event/getEventRangeThunk',
  async (range: string = '', thunkApi) => {
    const response = await eventService.getList(range);
    return response.data;
  },
);

export const removeEventThunk =
  (id: string) => (dispatch: ThunkDispatch<any, any, any>) => {
    return eventService
      .remove(id)
      .then(() => true)
      .catch((error: any) => {
        dispatch(errorHandlerThunk(error));
        return false;
      });
  };
